import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptSpeakersFetchFailedAction = {
	type: 'TRANSCRIPT_SPEAKERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptSpeakersFetchFailedAction => ({
	type: 'TRANSCRIPT_SPEAKERS_FETCH_FAILED',
	payload,
});
